import { ArrowRight } from "lucide-react";
import { HOW_TO_PLAY, PosterTitleHit, stagger } from "../homeShared";

const ROMAN = ["i", "ii", "iii", "iv"];

export default function Gallery({ art, actions, showBlurb, onTitleClick }) {
  const main = actions.filter((a) => a.tier !== "secondary");
  const rules = actions.find((a) => a.tier === "secondary");
  return (
    <div data-testid="home-design-gallery" className="hg hl-scroll lg:grid lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)]" style={{ background: art.paper }}>
      <div className="flex items-center justify-center p-6 lg:p-10 h-[78vh] lg:h-full min-h-0">
        <div className="relative h-full max-w-full hl-fade" style={{ aspectRatio: "1055 / 1491" }}>
          <img src={art.poster} alt="Porosity poster" className="w-full h-full object-contain" />
          <PosterTitleHit art={art} onClick={onTitleClick} />
        </div>
      </div>
      <div className="flex flex-col justify-center px-8 lg:pl-14 lg:pr-20 py-12 lg:py-10 lg:border-l border-[#E9E3D3]">
        <div className="hl-in text-[11px] font-semibold uppercase tracking-[.22em] text-[#0E6E70]" style={stagger(0)}>A board game for 2–4 players</div>
        <h2 className="hl-in hg-serif text-3xl lg:text-[2.6rem] leading-[1.12] mt-4 max-w-md" style={stagger(1)}>
          Build a shared city by the sea — <em className="text-[#0E6E70]">and make room for the water.</em>
        </h2>
        <div className="mt-9 flex flex-col gap-3 max-w-sm">
          {main.map((a, i) => (
            <button key={a.key} type="button" onClick={a.onClick} data-testid={a.testid} className={`hl-in hg-btn ${a.tier === "resume" ? "hg-btn--outline" : ""}`} style={stagger(i + 2)}>
              <a.Icon size={18} strokeWidth={1.8} /> {a.label}
              <ArrowRight size={18} strokeWidth={1.8} className="hg-arrow" />
            </button>
          ))}
        </div>
        <div className="hl-in mt-5" style={stagger(6)}>
          <button type="button" onClick={rules.onClick} data-testid={rules.testid} className="hg-link">
            <rules.Icon size={16} strokeWidth={1.8} /> Read the rulebook
          </button>
        </div>
        {showBlurb && (
          <ol data-testid="home-how-to-play" className="hl-in mt-10 pt-7 border-t border-[#E9E3D3] grid grid-cols-2 gap-x-8 gap-y-5 max-w-lg" style={stagger(7)}>
            {HOW_TO_PLAY.map((s, i) => (
              <li key={s.title}>
                <div className="hg-serif text-lg"><em className="text-[#0E6E70] mr-2">{ROMAN[i]}.</em>{s.title}</div>
                <p className="text-[13px] leading-relaxed text-[#5B5E58] mt-1">{s.text}</p>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}
